var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    class: { "fill-canvas": !_vm.value && !_vm.default_value },
    style: `
    border: 1px solid #ccc;
    width:20px ; height: 20px ; background-color: ${
      _vm.value || _vm.default_value || "transparent"
    } ;
            border-radius: 5px `,
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }